import { useDispatch } from 'react-redux';
import { MENU } from '../../../../AppConstants';
import { notification } from '../../../../utils/messaging';

const { TOGGLE_CATCH_REPORT, TOGGLE_AP_CROSSING } = MENU;

export const useMenuActions = (isLoggedIn) => {
  const dispatch = useDispatch();

  const openCatchReport = () => {
    if (!isLoggedIn) {
      notification.warning({
        description: 'Please login to share catch report',
      });
      return false;
    }
    dispatch({
      type: TOGGLE_CATCH_REPORT,
      showCatchReportDrawer: true,
      isRequestFromProfile: false,
    });
    return true;
  };

  const openCrossing = () => {
    dispatch({ type: TOGGLE_AP_CROSSING, showCrossingDrawer: true });
  };

  return { openCatchReport, openCrossing };
};
